import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "CampaignEditorRightColumn" }
const _hoisted_2 = ["value"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LoadingWrapper = _resolveComponent("LoadingWrapper")!

  return (_openBlock(), _createBlock(_component_LoadingWrapper, {
    classes: [
			'CampaignEditorRow',
			{ 'ContentInvalid': _ctx.isFieldValidatedAndMissing }
		],
    isLoading: _ctx.isLoading
  }, {
    default: _withCtx(() => [
      _cache[2] || (_cache[2] = _createElementVNode("div", { class: "CampaignEditorLeftColumn" }, [
        _createElementVNode("label", {
          class: "CampaignEditorInputLabel CampaignSettingsInputRequired",
          for: "CampaignSettingsInputName"
        }, " Name ")
      ], -1 /* CACHED */)),
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("input", {
          id: "CampaignSettingsInputName",
          class: "CampaignEditorInputField",
          type: "text",
          placeholder: "University Name_full EBP_Month_Year",
          value: _ctx.name,
          onInput: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.setNameBasedOnEvent && _ctx.setNameBasedOnEvent(...args)))
        }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_2),
        _cache[1] || (_cache[1] = _createElementVNode("div", { class: "ValidationMessage" }, " This field must be completed before proceeding ", -1 /* CACHED */))
      ])
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["classes", "isLoading"]))
}